module.exports = __webpack_public_path__ + "img/636d936a5da5716abb08b2bc8e8aa81b.svg";